import { Icon } from "@iconify/react";
import { gr } from "src/design-system/tokens";
import { useRef, useState } from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import ButtonBase from "@mui/material/ButtonBase";
// components
import MenuPopover from "./MenuPopover";
import { get_root_value } from "src/utils/domUtils";
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

export default function CustomPopover(props) {
  const anchorRef = useRef(null);
  const { menu, data } = props;

  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div
      style={{ cursor: "pointer", backgroundColor: "transparent" }}
      className="align-items-center d-flex justify-content-center remove-border menu-background-circle"
    >
      {/* Real button around the ⋮ icon (same look) so it works with keyboard and screen readers. */}
      <ButtonBase
        ref={anchorRef}
        onClick={handleOpen}
        aria-label="More options"
        aria-haspopup="menu"
        sx={{
          borderRadius: gr.radius.pill,
          "&.Mui-focusVisible": { boxShadow: gr.shadow.focus },
        }}
      >
        <MoreVertIcon
          style={{
            cursor: "pointer",
            fontSize: gr.icon.lg,
            color: get_root_value("--portal-theme-primary"),
            backgroundColor: "transparent",
          }}
          className="pointer custom-popover-icon"
        />
      </ButtonBase>
      <MenuPopover
        className="custom-popover"
        open={open}
        onClose={handleClose}
        anchorEl={anchorRef.current}
        sx={{ width: 160, marginLeft: 1.8, p: gr.space[1] }}
      >
        <MenuList autoFocusItem={open} sx={{ p: 0 }}>
          {menu.map((option) => (
            <MenuItem
              key={option.label}
              onClick={() => {
                setOpen(false);
                option.handleClick(data);
              }}
              // Same look as GrMenuItem (40px rows, 14px ink); optional `danger` (e.g. Delete) in red.
              sx={{
                minHeight: gr.control.md,
                borderRadius: gr.radius.chip,
                fontFamily: gr.font.family,
                fontSize: gr.font.size.md,
                color: option.danger ? gr.color.danger : gr.color.ink,
                "&:hover": {
                  background: option.danger
                    ? gr.color.dangerSoft
                    : gr.color.tint,
                },
              }}
            >
              {option.icon && (
                <Icon
                  fontSize="18"
                  style={{
                    color: option.danger
                      ? gr.color.danger
                      : "var(--portal-theme-primary)",
                  }}
                  className="me-2"
                  icon={option.icon}
                />
              )}
              <span>{option.label}</span>
            </MenuItem>
          ))}
        </MenuList>
      </MenuPopover>
    </div>
  );
}
